package com.essntl.features.organization.ui

import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.organization.domain.model.OrganizationModel
import com.mohamedrejeb.calf.core.PlatformContext

sealed interface OrganizationEvent {
    data class LoadOrganizations(val organization: OrganizationModel? = null) : OrganizationEvent
    data class SearchOrganization(val query: String) : OrganizationEvent
    data class UpdateOrganizationFields(val organization: OrganizationModel) : OrganizationEvent
    data class AddLogo(val file: FileModel) : OrganizationEvent
    data object DeleteLogo : OrganizationEvent
    data class InsertLogo(val context: PlatformContext) : OrganizationEvent
    data object ClearLogo : OrganizationEvent
    data object ClearOrganizationState : OrganizationEvent
    data class AddRemoveAddress(val addAddress: Boolean? = null) : OrganizationEvent
    data class SetParentOrganization(val organization: OrganizationModel) : OrganizationEvent
}